export const ArrowIcon = () => {
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.64645 7.35355C3.84171 7.54882 4.15829 7.54882 4.35355 7.35355L7.53553 4.17157C7.7308 3.97631 7.7308 3.65973 7.53553 3.46447C7.34027 3.2692 7.02369 3.2692 6.82843 3.46447L4 6.29289L1.17157 3.46447C0.976311 3.2692 0.659728 3.2692 0.464466 3.46447C0.269204 3.65973 0.269204 3.97631 0.464466 4.17157L3.64645 7.35355ZM3.5 0L3.5 7H4.5V0L3.5 0Z"
        fill="black"
      />
    </svg>
  );
};

export const PlusIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.125 0.874999C6.125 0.39175 6.51675 -8.34465e-07 7 -8.34465e-07C7.48325 -8.34465e-07 7.875 0.39175 7.875 0.874999V6.125L13.125 6.125C13.6082 6.125 14 6.51675 14 7C14 7.48325 13.6082 7.875 13.125 7.875L7.875 7.875V13.125C7.875 13.6082 7.48325 14 7 14C6.51675 14 6.125 13.6082 6.125 13.125V7.875L0.875 7.875C0.391751 7.875 0 7.48325 0 7C0 6.51675 0.391751 6.125 0.875 6.125L6.125 6.125V0.874999Z"
        fill="#989898"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.84198" cy="7.60528" r="6.65789" stroke="#989898" />
      <line
        x1="4"
        y1="12.8913"
        x2="0.707107"
        y2="16.1842"
        stroke="#989898"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const FavoriteIcon = ({ isFav = false }: { isFav?: boolean }) => {
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill={isFav ? '#e3b341' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.7343 14.3915C1.73441 14.9529 0.500001 14.2303 0.500001 13.0836L0.500002 3.5C0.500003 2.11929 1.61929 0.999998 3 0.999998L11 0.999999C12.3807 0.999999 13.5 2.11929 13.5 3.5L13.5 13.0836C13.5 14.2303 12.2656 14.9529 11.2657 14.3915L7.7343 12.409C7.27825 12.153 6.72176 12.153 6.2657 12.409L2.7343 14.3915Z"
        stroke="#e3b341"
      />
    </svg>
  );
};

export const DotsIcon = ({ w, h }: { w?: number; h?: number }) => {
  return (
    <svg
      width={w ? w : 18}
      height={h ? h : 5}
      viewBox="0 0 18 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse
        cx="2.11766"
        cy="2.50005"
        rx="2.11766"
        ry="2.04546"
        fill="#989898"
      />
      <ellipse
        cx="8.99998"
        cy="2.50005"
        rx="2.11766"
        ry="2.04546"
        fill="#989898"
      />
      <ellipse
        cx="15.8823"
        cy="2.50005"
        rx="2.11766"
        ry="2.04546"
        fill="#989898"
      />
    </svg>
  );
};

export const EyeIcons = () => {
  return (
    <svg
      width="24"
      height="10"
      viewBox="0 0 24 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5415 4.17925C16.5415 6.83982 14.5039 9 11.9942 9C9.48456 9 7.4469 6.83982 7.4469 4.17925C7.4469 3.2151 7.71168 2.31198 8.17792 1.5553C9.36368 1.20748 10.6415 1 11.9942 1C13.3469 1 14.6248 1.22578 15.8335 1.59192C16.2825 2.34249 16.5415 3.22731 16.5415 4.17925Z"
        stroke="#989898"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8336 1.5918C19.1664 2.60476 21.8718 4.69782 23 6.15625"
        stroke="#989898"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 6.15722C2.49659 4.4425 5.00049 2.48979 8.17786 1.55615"
        stroke="#989898"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const FullIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 14C0.89543 14 1.40906e-07 13.1046 3.14722e-07 12L6.29444e-07 10C7.16352e-07 9.44771 0.447716 9 1 9C1.55229 9 2 9.44772 2 10L2 11C2 11.5523 2.44772 12 3 12L4 12C4.55228 12 5 12.4477 5 13C5 13.5523 4.55228 14 4 14L2 14Z"
        fill="#989898"
      />
      <path
        d="M12 -2.18557e-08C13.1046 5.05677e-08 14 0.895431 14 2L14 4C14 4.55228 13.5523 5 13 5C12.4477 5 12 4.55228 12 4L12 3C12 2.44772 11.5523 2 11 2L10 2C9.44772 2 9 1.55228 9 1C9 0.447715 9.44772 -1.89202e-07 10 -1.5299e-07L12 -2.18557e-08Z"
        fill="#989898"
      />
      <path
        d="M14 12C14 13.1046 13.1046 14 12 14L10 14C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12L11 12C11.5523 12 12 11.5523 12 11L12 10C12 9.44772 12.4477 9 13 9C13.5523 9 14 9.44772 14 10L14 12Z"
        fill="#989898"
      />
      <path
        d="M0 2C0 0.89543 0.895431 0 2 0H4C4.55228 0 5 0.447715 5 1C5 1.55228 4.55228 2 4 2H3C2.44772 2 2 2.44772 2 3V4C2 4.55228 1.55228 5 1 5C0.447715 5 0 4.55228 0 4V2Z"
        fill="#989898"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="12.6"
        width="1.9799"
        height="17.8191"
        rx="0.989949"
        transform="rotate(45 12.6 0)"
        fill="#989898"
      />
      <rect
        x="14"
        y="12.6001"
        width="1.9799"
        height="17.8191"
        rx="0.989949"
        transform="rotate(135 14 12.6001)"
        fill="#989898"
      />
    </svg>
  );
};

export const SendIcon = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.12029 0.627459L0.797577 16.0245C0.437427 16.6908 0.919898 17.5 1.67728 17.5H4.3594C5.09414 17.5 5.80334 17.2304 6.35249 16.7422L8.33564 14.9794C8.98054 14.4062 10 14.864 10 15.7268V19.0855C10 20.0376 11.2048 20.451 11.7894 19.6994L12.5992 18.6582C13.1676 17.9274 14.0415 17.5 14.9673 17.5H18.3227C19.0801 17.5 19.5626 16.6908 19.2024 16.0245L10.8797 0.627457C10.5017 -0.0718536 9.4983 -0.071852 9.12029 0.627459Z"
        fill="#7BC7F2"
      />
    </svg>
  );
};
